<template>
  <el-config-provider :locale="_elementLocale">
    <component :is="meta?.layout || 'div'" :key="meta?.layout || 'div'">
      <RouterView />
    </component>
  </el-config-provider>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import ru from 'element-plus/es/locale/lang/ru'
import kk from 'element-plus/es/locale/lang/kk'
import { useAuthStore } from '@/stores/auth.store'

const { getCurrentUser } = useAuthStore()
if (localStorage.getItem('token')) {
  getCurrentUser()
}

const route = useRoute()
const meta = computed(() => route.meta)

// Тексты Element Plus (пустая таблица, «Нет данных», подтверждения) — на языке интерфейса.
const { locale, t } = useI18n()
const _elementLocale = computed(() => (locale.value === 'kz' ? kk : ru))

// Заголовок вкладки ставит роутер при переходе; при смене языка — здесь.
watch(locale, () => {
  document.title = route.meta.title ? `${t(route.meta.title)} — Novator` : t('app.name')
})
</script>
